import { render, staticRenderFns } from "./DocumentsCreatePE.vue?vue&type=template&id=1a715639&scoped=true"
import script from "./DocumentsCreatePE.vue?vue&type=script&lang=js"
export * from "./DocumentsCreatePE.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCreatePE.vue?vue&type=style&index=0&id=1a715639&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a715639",
  null
  
)

export default component.exports